export default __webpack_public_path__ + "static/media/gearIcon.d274c8b3.svg";